import qs from 'qs';
import client from './client';

const esgUrl = '/api/v1/sys/esg';

// ESG 리스트
export const getEsgBoards = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${esgUrl}/list?${queryString}`);
};

// ESG 추가
export const addEsgBoard = (dataToSubmit) => {
  return client.post(`${esgUrl}/info`, dataToSubmit);
};

// ESG 상세
export const getEsgBoard = (id) => client.get(`${esgUrl}/info/${id}`);

// ESG 수정
export const editEsgBoard = (id, dataToSubmit) => {
  return client.put(`${esgUrl}/info/${id}`, dataToSubmit);
};

// ESG 삭제
export const removeEsgBoard = (id) => client.delete(`${esgUrl}/info/${id}`);

// ESG 첨부파일 리스트
export const getEsgFiles = ({ fileTyp, fileAttrVal1 }) => {
  const queryString = qs.stringify({ fileTyp, fileAttrVal1 });
  return client.get(`/api/v1/file/list?${queryString}`);
};
